import { AuthorizationService } from "./authorization";
import { LoggingService } from "../loggingSvc";
import { ServiceDeskConfig } from "../../Startup/serviceDeskConfig";

// @ngInject
export function authorizationFilter(
  authorizationService: AuthorizationService,
  loggingService: LoggingService,
  sdConfig: ServiceDeskConfig
) {
  let knownApplicationNames = new Map<string, number>();
  knownApplicationNames.set("servicedesk", sdConfig.sdAuthorizationAppId);

  return function (rightName: string, applicationNameOrId: string) {
    let knownAppKey = applicationNameOrId.toLowerCase();
    let knownAppId = knownApplicationNames.get(knownAppKey);
    if (!knownAppId) {
      // If the appName is now known, assume they are passing an app id.
      knownAppId = parseInt(applicationNameOrId);
      if (!knownAppId) {
        loggingService.logError(
          "An invalid application was provided for authorization. All checks will be considered denied."
        );
        return false;
      }
    }

    return authorizationService.hasRight(rightName, knownAppId);
  };
}
